<template>
  <div v-for="(arrayValue, arrayIndex) in arrayValues" :key="arrayIndex">
    {{ t(`enums.${arrayValue.toUpperCase()}`) }}
  </div>
</template>

<script setup lang="ts">
/***
 * template to show array of enums
 */
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import type { DataTableCellProps } from './templateTypes';
const { t } = useI18n();
const props = defineProps<DataTableCellProps>();
const { cell } = props;

// Ensure we always work with an array, even if a single string was passed
const arrayValues = computed(() => {
  const value = cell.meta?.('rawvalue') ?? cell.value;
  return Array.isArray(value) ? value : [value];
});
</script>
